import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/app/store';
import { selectIsAuthenticated } from '@/app/store/slices/auth.slice';

interface GuestGuardProps {
  children: React.ReactNode;
}

/**
 * Protects routes that should only be accessible to non-authenticated users
 * Redirects to dashboard if user is already authenticated
 */
export function GuestGuard({ children }: GuestGuardProps) {
  const location = useLocation();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  // Get the intended destination from location state
  const from = (location.state as { from?: { pathname: string } })?.from?.pathname || '/dashboard';

  // Redirect to dashboard (or intended destination) if already authenticated
  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
}
